import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import TowerEffect from "@/Components/TowerEffect/hyTower";
import Charts from "./chartHtml";
import { hyInputs, hyParamsMap } from "./hyInput";
import { getJob, hydraulics } from "@/services/common";
import userInfo from "@/Components/user";
import "./hydraulics.less";
import { Spin } from "antd";

const units = [
  { id: "kg/h", label: "kg/h", value: "kg/h", color: "#007cdc" },
  { id: "m3/h", label: "m³/h", value: "m3/h", color: "#007cdc" },
  { id: "m3/s", label: "m³/s", value: "m3/s", color: "#007cdc" },
];

const HydraulicsComponent = (props: any) => {
  const { multiTaskData, inputs, scrollViewRef } = props;
  const sectionPositions = useRef<Record<string, number>>({});
  const [curTrayNo, setCurTrayNo] = useState<number>(0);
  const [calInputs, setCalInputs] = useState<any>(null);
  const [hyResult, setHyResult] = useState<any>(null);
  const [modalStatus, setModalStatus] = useState<boolean>(false);
  const [paramListStatus, setParamListStatus] = useState<boolean>(false);
  const [unit, setUnit] = useState<string>("kg/h");
  const [hyError, setHyError] = useState<string>("");
  const params = useParams();
  const flowId = params.f;

  const activeTaskResult = multiTaskData?.[0]?.result;

  useEffect(() => {
    setCurTrayNo(0);
  }, [multiTaskData, inputs]);

  useEffect(() => {
    if (!activeTaskResult || !inputs) return;

    const newInputs = {
      device_config: {
        ...hyInputs.device_config,
        D: inputs.params.D_col,
        // A_d_ratio: Number(
        //   (1.22 / ((Math.PI * inputs.params.D_col * inputs.params.D_col) / 4)).toFixed(4)
        // ),
        phi_hole: Number(
          (1.02 / ((Math.PI * inputs.params.D_col * inputs.params.D_col) / 4)).toFixed(4)
        ),
        d_o: inputs.params.d_hole,
      },
      stream_config: {
        ...hyInputs.stream_config,
        L_op: activeTaskResult.result.L_kg_per_h[curTrayNo],
        V_op: activeTaskResult.result.V_kg_per_h[curTrayNo],
        rhoL_op: activeTaskResult.result.rho_L[curTrayNo],
        rhoV_op: activeTaskResult.result.rho_V[curTrayNo],
        sigma_op: activeTaskResult.result.sigma[curTrayNo],
      },
    };
    setCalInputs(newInputs);

    let isCanceled = false;
    const fetchHydraulics = async () => {
      try {
        // const overAll = {
        //   name: "hydraulics新计算任务",
        //   flow_id: flowId,
        //   description: null,
        //   cal: "True",
        //   mix_input: newInputs,
        // };
        const hydraulicsRes = await hydraulics(newInputs, userInfo.access_token);
        // const jobRes = await getJob(newInputs, userInfo.access_token);
        // console.log('jobRes', jobRes.data);
        setHyResult({
          status:hydraulicsRes.status,
          result: hydraulicsRes.data,
        });
        if (isCanceled) return;

        // if (jobRes.status === 200) {
        //   const outputData = JSON.parse(jobRes.data.output);
        //   setHyResult({
        //     status: jobRes.data.status,
        //     result: outputData,
        //   });
        //   setHyError("");
        // }
      } catch (err) {
        console.error("水力学计算异常：", err);
        if (!isCanceled) setHyError("接口请求失败，请重试");
      }
    };
    fetchHydraulics();
    return () => { isCanceled = true; };
  }, [activeTaskResult, curTrayNo, inputs]);

  const scrollto = () => {
    handleScrollTo("inputArea");
  };

  const scrolltoChart = () => {
    const yPosition = sectionPositions.current["inputArea"] || 0;
    if (scrollViewRef.current) {
      scrollViewRef.current.scrollTop = yPosition + 600;
    }
  };

  const handleScrollTo = (sectionId: string) => {
    const yPosition = sectionPositions.current[sectionId] || 0;
    if (scrollViewRef.current) {
      scrollViewRef.current.scrollTop = yPosition + 400;
    }
  };

  const handleLayout = (sectionId: string, domNode: HTMLDivElement) => {
    if (!domNode) return;
    const y = domNode.getBoundingClientRect().top;
    sectionPositions.current[sectionId] = y;
  };

  const showInputParams = () => {
    if (!calInputs) return null;
    return (
      <div className={`inputs-list ${paramListStatus ? "show" : "hide"}`}>
        {Object.keys(calInputs.device_config).map((key) => (
          <div key={key} className="input-item">
            <div className="input-label-container">
              <span className="input-label">{hyParamsMap[key].label}：</span>
            </div>
            <div className="input-value-container">
              <input
                type="number"
                className="input-value"
                defaultValue={calInputs.device_config[key].toString()}
                onChange={(e) => {
                  setCalInputs({
                    ...calInputs,
                    device_config: {
                      ...calInputs.device_config,
                      [key]: isNaN(Number(e.target.value)) ? 0 : Number(e.target.value),
                    },
                  });
                }}
              />
              <span className="input-unit">{hyParamsMap[key].unit}</span>
            </div>
          </div>
        ))}
        <div className="input-btn-group">
          <button className="sub-button" onClick={() => {
            setParamListStatus(false);
            scrolltoChart();
          }}>
            <span className="sub-button-text">确定</span>
          </button>
          <button className="cancle-button" onClick={() => setParamListStatus(false)}>
            <span className="cancle-button-text">关闭</span>
          </button>
        </div>
      </div>
    );
  };

  const showMultiTaskResults = () => {
    if (!hyResult || hyResult.status !== 200) {
      return (
        <div className="error-container">
          <span className="error-text">{hyError || <Spin />}</span>
        </div>
      );
    }

    return (
      <div className="multi-task-charts-container">
        {multiTaskData.map((task) => {
          return (
            <div key={task.taskId} className="task-chart-group">
              <Charts
                trayNo={curTrayNo}
                hyResult={hyResult}
                unit={unit}
                name={`${task.taskName}`}
              />
            </div>
          );
        })}
      </div>
    );
  };

  const renderUnitSelector = () => (
    <div className="unit-selector">
      <span className="selected-unit-btn-title">切换流量单位：</span>
      <div className="radio-group">
        {units.map((item) => (
          <label key={item.id} className="radio-label">
            <input
              type="radio"
              name="unit"
              value={item.id}
              checked={unit === item.id}
              onChange={() => setUnit(item.id)}
              className="radio-input"
            />
            <span className="radio-label-text">{item.label}</span>
          </label>
        ))}
      </div>
    </div>
  );

  // ==============================================
  // 核心改动：按类型分三行，所有任务横向排列
  // ==============================================
  const renderTowerEffectsByType = () => {
    if (!multiTaskData || multiTaskData.length === 0) return null;

    return (
      <div className="multi-task-towers-wrap">

        {/* 第一行：气相体积流量分布 */}
        <div className="effect-section">
          <h2 className="section-title">塔板气相体积流量分布</h2>
          <div className="tower-effects-container">
            {multiTaskData.map((task) => (
              <div key={`gas-${task.taskId}`} className="eff-container">
                <h3 className="eff-title">{task.taskName}</h3>
                <div className="eff-content">
                  <TowerEffect
                    currentMode={null}
                    currentData={null}
                    setCurrentData={null}
                    currentModeData={task.result?.result?.hydraulics?.Q_V || []}
                    wrapWidth={280}
                    trayHeight={290}
                    imageStyle={{ height: 400, width: 80 }}
                    trayContainerStyle={{ top: 40, left: 27, width: 47 }}
                    unit="m³/h"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* 第二行：液相体积流量分布 */}
        <div className="effect-section">
          <h2 className="section-title">塔板液相体积流量分布</h2>
          <div className="tower-effects-container">
            {multiTaskData.map((task) => (
              <div key={`liquid-${task.taskId}`} className="eff-container">
                <h3 className="eff-title">{task.taskName}</h3>
                <div className="eff-content">
                  <TowerEffect
                    currentMode={null}
                    currentData={null}
                    setCurrentData={null}
                    currentModeData={task.result?.result?.hydraulics?.Q_L || []}
                    wrapWidth={280}
                    trayHeight={290}
                    imageStyle={{ height: 400, width: 80 }}
                    trayContainerStyle={{ top: 40, left: 27, width: 47 }}
                    unit="m³/h"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* 第三行：塔板压降分布 */}
        <div className="effect-section">
          <h2 className="section-title">塔板压降分布</h2>
          <div className="tower-effects-container">
            {multiTaskData.map((task) => (
              <div key={`dp-${task.taskId}`} className="eff-container">
                <h3 className="eff-title">{task.taskName}</h3>
                <div className="eff-content">
                  <TowerEffect
                    currentMode={null}
                    currentData={null}
                    setCurrentData={null}
                    currentModeData={task.result?.result?.hydraulics?.delta_P_tray?.map((i: any) => Number(i)) || []}
                    wrapWidth={280}
                    trayHeight={290}
                    imageStyle={{ height: 400, width: 80 }}
                    trayContainerStyle={{ top: 40, left: 27, width: 47 }}
                    unit="Pa"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>

      </div>
    );
  };

  return (
    <div className="hydraulics-container multi-task-hydraulics">

      {/* 塔板分布图：按类型分三行 */}
      {renderTowerEffectsByType()}

      {/* 控制区 + 负荷图 */}
      <div className="cal-container">
        <div className="cal-header">
          <div className="cal-header-left">
            <h3 className="cal-title">塔板性能负荷计算：</h3>
            <div className="selected-tray-container">
              <button className="selected-tray-btn" onClick={() => setModalStatus(true)}>
                <span className="selected-tray-btn-title">切换塔板：</span>
                <span className="selected-tray">{curTrayNo + 1}# 塔板</span>
                <span className="caret-icon">▼</span>
              </button>
            </div>
            {renderUnitSelector()}
          </div>
          <div className="extra-area">
            {/* <button className="setting-btn" onClick={() => {
              setParamListStatus(!paramListStatus);
              if (!paramListStatus) scrollto();
            }}>
              <span className="gear-icon">⚙️</span>
              <span className="setting-btn-text">塔板参数</span>
            </button> */}
          </div>
        </div>

        <div ref={(el) => el && handleLayout("inputArea", el)} className="cal-input-container">
          {showInputParams()}
        </div>

        {showMultiTaskResults()}
      </div>

      {modalStatus && (
        <div className="modal-overlay">
          <div className="modal-wrap">
            <div className="modal-header">
              <h3 className="modal-title">选择塔板：</h3>
              <button className="modal-close-btn" onClick={() => setModalStatus(false)}>×</button>
            </div>
            <div className="modal-content">
              {Array.from({ length: inputs?.params?.N || 0 }).map((_, i) => (
                <button key={i} className={`tray-btn ${curTrayNo === i ? "active" : ""}`} onClick={() => {
                  setCurTrayNo(i);
                  setModalStatus(false);
                }}>
                  <span className="tray-btn-text">{`${i + 1}# 塔板`}</span>
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default HydraulicsComponent;